import type { Theme } from '@mui/material/styles';
import { getOpenXAgentGradient } from '../colors';

export const getNavbarStyles = (isDragging: boolean) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  px: 2,
  py: 1.5,
  borderBottom: '1px solid',
  borderColor: 'divider',
  backgroundColor: 'background.paper',
  cursor: isDragging ? 'grabbing' : 'grab',
  userSelect: 'none',
  height: '60px',
});

export const getNavbarIconStyles = (theme: Theme) => ({
  width: 28,
  height: 28,
  borderRadius: '4px',
  background: getOpenXAgentGradient(theme),
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexShrink: 0,
  pb: 0.25,
});
